<template>
  <div>
    <div class="view-header">
      <h1>{{$store.state.meta.title}}</h1>
      <div class="func-list">
        <el-button type="primary" plain @click="onExport">项目报告导出</el-button>
      </div>
    </div>
    <div class="user-info" v-if="userinfo">
      <h3>授权人信息</h3>
      <ul class="userinfo">
        <li>
          <span class="title">授权人手机：</span>
          <p>{{userinfo.phone}}</p>
        </li>
        <li>
          <span class="title">授权人姓名：</span>
          <p>{{userinfo.user_name}}</p>
        </li>
        <li>
          <span class="title">授权产品：</span>
          <p>{{userinfo.goods_name}}</p>
        </li>
        <li>
          <span class="title">授权到期时间：</span>
          <p>{{userinfo.update_time}}</p>
        </li>
      </ul>
    </div>
    <el-divider content-position="left"></el-divider>
    <div class="table">
      <el-table
        size="medium"
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="template_title"
          label="项目报告名称"
        >
        </el-table-column>
        <el-table-column
          prop="attr_name"
          label="项目报告分类"
        >
        </el-table-column>
        <el-table-column
          prop="report_num"
          label="项目报告数量"
        >
          <template slot-scope="scope">
            {{scope.row.report_num}}份
          </template>
        </el-table-column>
        <el-table-column
          prop="template_title"
          label="项目报告状态"
        >
          <template slot-scope="scope">
            {{scope.row.activation_status==1?'已激活':'未激活'}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              :disabled="scope.row.report_num == 0"
              type="text"
              @click="toView(scope.row)">
              查看明细
            </el-button>
            <el-button
              type="text"
              @click="toViewExample(scope.row)">
              查看报告示例
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :width="'700px'"
      :visible.sync="dialogVisible"
    >
      <div style="font-size: 14px;color:#000;height:708px;overflow:auto;">
        <p style="font-size:12px;color:#999;">芒哥-合规证据链系统</p>
        <h4 style="font-size: 18px;margin-bottom:10px;text-align:center;">
          《{{templateExample.template_title}}》</h4>
        <table border="1" cellspacing="0" cellpadding="1" style="width:100%;text-align:left;">
          <tr v-for="item in templateExample.textList">
            <td v-for="item2 in item">
              {{item2.field_name}}<span v-if="item2.field_name">：xxxxxx</span>
            </td>
          </tr>
        </table>
        <!--       照片-->
        <div v-for="item in templateExample.imgList" style="margin-top:20px;">
          <p>{{item.field_name}}：</p>
          <table border="0" cellspacing="0" cellpadding="1" style="width:100%;">
            <tr>
              <td>
                <el-image class="img-placeholder">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" style="font-size:40px;"></i>
                  </div>
                </el-image>
              </td>
              <td>
                <el-image class="img-placeholder">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" style="font-size:40px;"></i>
                  </div>
                </el-image>
              </td>
            </tr>
          </table>

        </div>
        <!--       签名-->
        <!--<div v-for="item in templateExample.signatureList" style="margin-top:20px;">
          <p>{{item.field_name}}：</p>
          <el-image
            style="width:100px;height:50px;text-align:center;line-height:50px;border:1px solid #ddd;">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>-->
        <div style="display: flex;align-items: center;margin-top:90px;">
          <p>提交人：xxxxx</p>
          <p style="margin-left: 20px;">提交日期：xxxx-xx-xx</p>
        </div>
        <!-- <p>所属服务商：xxxxx</p> -->
        <p style="text-align:right;margin-top:20px;">报告提交人：xxxxx</p>
        <p style="font-size:11px;color:#999;text-align:right;margin-top:20px;">项目报告均由芒哥-合规证据链系统自成生成</p>
        <p style="font-size:11px;color:#999;text-align:right;">Project reports are generated by the Mango-Service Business Management Platform</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTemplateList, empowerUserInfo, templateField } from '@/api';
import { titleMultiLine } from '@/utils/util';

export default {
  name: 'TemplateList',
  beforeCreate() {
    this.user_id = this.$route.params.user_id;
  },
  data: () => ({
    userinfo: null,
    list: [],
    dialogVisible: false,
    templateExample: {},
  }),
  created() {
    empowerUserInfo(this.user_id).then((res) => {
      if (res.status === 0) {
        this.userinfo = res.data;
      }
    });
    let param= {user_id: this.user_id, is_person: 1}
    getTemplateList(param).then((res) => {
      if (res.status === 0) {
        this.list = res.data.template;
      } else {
        this.list = [];
      }
    });
  },
  methods: {
    titleMultiLine,
    toView({ user_have, template_id, template_title }) {
      if (user_have == 0) {
        const h = this.$createElement;
        this.$confirm('<p>该模版暂未激活，如想了解详情或激活，</p><p>请联系：400-118-0106</p>', template_title, {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          showCancelButton: false,
          type: 'warning',
        });
        return;
      }


      this.$router.push({
        name: 'userReport',
        params: { template_id, user_id: this.user_id },
      });
    },
    onExport() {
      this.$router.windowOpen({
        name: 'reportExport',
        params: { user_id: this.user_id, template_id: '-1' },
      });
    },
    toViewExample({ template_id, template_title }) {
      const templateExample = { template_title };
      templateField(template_id).then((res) => {
        if (res.status === 0) {
          const list = res.data;
          const imgList = [];
          const signatureList = [];
          const valueList = [];
          for (const item of list) {
            switch (item.field_type) {
              // 图片
              case 9:
                imgList.push(item);
                break;
                // 签名
              case 11:
                signatureList.push(item);
                break;
              default:
                valueList.push(item);
                break;
            }
          }
          // 文字类型，两两一行
          const textList = [];
          for (let i = 0; i < valueList.length; i += 2) {
            textList.push(valueList.slice(i, i + 2));
          }
          if (textList.length > 0) {
            if (textList[textList.length - 1].length < 2) {
              textList[textList.length - 1].push({});
            }
          }

          templateExample.imgList = imgList;
          templateExample.signatureList = signatureList;
          templateExample.textList = textList;
          this.templateExample = templateExample;
          this.dialogVisible = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .func-list {
    float: right;
  }

  .template-list {
    padding: 30px 54px;
  }

  .list {
    margin-bottom: 34px;

    .list-title {
      margin-bottom: 20px;
      padding: 0 10px;
      font-size: 20px;
      color: #000;
      font-weight: 600;
    }

    .list-content {
      &:after {
        display: block;
        content: ' ';
        clear: both;
      }

      li {
        float: left;
        padding: 10px;
        width: 20%;

        a {
          padding: 0 10px;
          width: 100%;
          max-width: 168px;
          height: 65px;
          text-align: center;
          line-height: 65px;
          display: block;
          border: 1px solid $border-color;
          border-radius: 4px;
          color: $default-text-color;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          word-break: keep-all;

          &:hover {
            color: $color-primary;
          }

          &.is-disabled {
            border-color: $disabled-border-color;
            color: $disabled-text-color;
            cursor: not-allowed;

            &:hover {
              border-color: $disabled-border-color;
              color: $disabled-text-color;
            }
          }
        }
      }
    }
  }

  .userinfo {
    margin-bottom: 40px;
    padding-right: 78px;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 100px;
      font-size: 14px;

      .title {
        position: absolute;
        left: 0;
        width: 100px;
        text-align: right;
        color: #787a7a;
      }
    }
  }

  .img-placeholder {
    width: 87%;
    background: #f5f7fa;
    color: #909399;
    height: 200px;
    text-align: center;
    line-height: 200px;
  }
  .user-info{
    padding: 0 40px;
    h3{
      margin-bottom: 10px;
    }
  }
</style>
